export default [
    {
        path: 'subgrupo',
        component: () => import(
            /* webpackChunkName: 'cadastro-subgrupo' */
            '@/views/cadastro/subgrupo/Index'
        ),
        redirect: 'subgrupo/index',
        children: [
            {
                name: 'cadastro-subgrupo-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'cadastro-subgrupo' */
                    '@/views/cadastro/subgrupo/List.vue'
                ),
            },
            {
                name: 'cadastro-subgrupo-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'cadastro-subgrupo' */
                    '@/views/cadastro/subgrupo/Form.vue'
                ),
            },
            {
                name: 'cadastro-subgrupo-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'cadastro-subgrupo' */
                    '@/views/cadastro/subgrupo/Form.vue'
                ),
            },
        ],
    },
]